export default __webpack_public_path__ + "static/media/arrow__right-indigo.d2d5f5ab.svg";